export class WindowResizeService {
  private resizeTimeout: number | null = null;
  private readonly DEBOUNCE_DELAY = 25;

  constructor() {
    window.addEventListener('resize', () => {
      this.handleResize();
    });
  }

  private handleResize(): void {
    if (this.resizeTimeout) {
      window.clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = window.setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent('debouncedResize', {
          detail: {
            width: window.innerWidth,
            height: window.innerHeight,
          },
        }),
      );
    }, this.DEBOUNCE_DELAY);
  }
}
